import React from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';

const Select = ({label, name, help, onChange, options, disabled, validators, unselected, displayValueAsHelp}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name] ?? '';
    const {isValid, error} = useValidators(value, validators, name, updateValidity);

    const handleChange = (e) => {
        updateField(name, e.target.value);
        onChange && onChange(e.target.value);
    }

    const isDisabled = formDisabled || disabled || isSubmitting;
    const theHelp = displayValueAsHelp ? value : help;

    return <CommonFieldWrapper {...{label, name, help: theHelp, value, isValid, isValidating, error, validators, isDisabled}}>

        <select
            id={name}
            name={name}
            className="block w-full ml-1 p-0 border-0 border-transparent focus:border-transparent text-gray-900 sm:text-sm sm:leading-6 disabled:text-gray-400 disabled:bg-gray-100"
            defaultValue={value}
            onChange={handleChange}
            disabled={isDisabled}
        >
            {unselected && <option value="">{unselected}</option>}

            {options.map((option, index) => {
                if (typeof option === 'string') {
                    return <option key={index} value={option}>{option}</option>
                } else {
                    return <option key={index} value={option.value}>{option.label}</option>
                }
            })}
        </select>

    </CommonFieldWrapper>
}

export default Select;
